var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { FontWeights, Stack } from "@fluentui/react";
import { useClasses } from "../../utils/useClasses";
import { Text } from "../texts/Text";
var getClasses = function (theme) { return ({
    container: {
        background: theme.palette.white,
    },
    description: {
        fontWeight: FontWeights.regular,
    }
}); };
export var FormDescriptionControl = function (props) {
    var className = props.className, description = props.description, forwardProps = __rest(props, ["className", "description"]);
    var classes = useClasses(getClasses);
    if (!description)
        return null;
    return _jsx(Stack, __assign({ className: classes.container + " " + className, horizontal: true }, forwardProps, { children: _jsx(Stack.Item, __assign({ grow: true }, { children: typeof description === "string"
                ? _jsx(Text, __assign({ className: classes.description, nowrap: false }, { children: description }), void 0)
                : description }), void 0) }), void 0);
};
//# sourceMappingURL=FormDescriptionControl.js.map